module.exports = __webpack_public_path__ + "static/media/redMutagen.19422683.png";